import { edkt } from '@airgrid/edgekit';
import { PageViewCounts } from 'ts-types';

export const getTotalPageViews = (): number => edkt.getCopyOfPageViews().length;

class PageViewAnalytics {
  TODAY: number;
  ONE_DAY: number;
  ONE_WEEK: number;
  ONE_WEEK_AGO: number;
  YESTERDAY: number;
  SNAPSHOT_DATE_KEY: string;
  hasSnapshotSentToday: boolean;

  constructor() {
    this.TODAY = new Date().setUTCHours(0, 0, 0, 0);
    this.ONE_DAY = 24 * 60 * 60 * 1000;
    this.ONE_WEEK = this.ONE_DAY * 7;
    this.ONE_WEEK_AGO = this.TODAY - this.ONE_WEEK;
    this.YESTERDAY = this.TODAY - this.ONE_DAY;
    this.SNAPSHOT_DATE_KEY = 'edkt_snapshot_date';
    this.hasSnapshotSentToday = this._hasSnapshotSentToday();
  }

  _hasSnapshotSentToday = (): boolean => {
    const lastSnapshotDate =
      Number(localStorage.getItem(this.SNAPSHOT_DATE_KEY)) || null;
    if (!lastSnapshotDate) return false;
    return !(lastSnapshotDate < this.TODAY);
  };

  _setSnapshotSentDate = (): void => {
    const stringDate = this.TODAY.toString();
    localStorage.setItem(this.SNAPSHOT_DATE_KEY, stringDate);
  };

  // TODO: We should switch EdgeKit to use TS in millis.
  _timeStampToMillis = (ts: number): number => ts * 1000;

  _isTimeStampYesterday = (ts: number): boolean => {
    return ts < this.TODAY && ts > this.YESTERDAY;
  };

  _isTimeStampInPastWeek = (ts: number): boolean => {
    return ts < this.TODAY && ts > this.ONE_WEEK_AGO;
  };

  get = (): PageViewCounts | null => {
    if (this.hasSnapshotSentToday) return null;

    const pageViews = edkt.getCopyOfPageViews();
    const totalPageViews = pageViews.length;

    const pageViewsYesterday = pageViews.filter((pageView) => {
      const timeStampInMillis = this._timeStampToMillis(pageView.ts);
      return this._isTimeStampYesterday(timeStampInMillis);
    }).length;

    const pageViewsInPastWeek = pageViews.filter((pageView) => {
      const timeStampInMillis = this._timeStampToMillis(pageView.ts);
      return this._isTimeStampInPastWeek(timeStampInMillis);
    }).length;

    this._setSnapshotSentDate();

    return {
      totalPageViews,
      pageViewsYesterday,
      pageViewsInPastWeek,
    };
  };
}

export const pageViewAnalytics = new PageViewAnalytics();
